import React, { useRef } from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";

import { useLSContainerCycles } from "../hooks/useLSContainerCycles";

export const LSWidgetContainer = (props: {
	eventId: string;
	location: WidgetLocation;
	divProps?: React.HTMLProps<HTMLDivElement>;
}) => {
	const widgetRef = useRef<HTMLDivElement>(null);
	const t = useTranslation().t;

	const isError = useLSContainerCycles(
		widgetRef,
		props.eventId,
		props.location
	);

	return (
		<>
			<div ref={widgetRef} {...props.divProps}></div>
			{isError && (
				<div
					className={
						props.location == WidgetLocation.SIDE
							? "u-padd--xsml"
							: ""
					}
				>
					<InfoMessageComponent
						type="note"
						size="base"
						message={t<string>("LIVE_WIDGET.FALLBACK_MESSAGE")}
					/>
				</div>
			)}
		</>
	);
};
